import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import { queryClient } from './queryClient'

import { Home } from './pages/Home'
import { Album } from './pages/Album'
import { ImageDetail } from './pages/ImageDetail'
import { Admin } from './pages/Admin'
import { Upload } from './pages/Upload'
import { Login } from './pages/Login'
import { OAuthCallback } from './pages/OAuthCallback'
import { NotFound } from './pages/NotFound'
import { AlbumManagement } from './pages/AlbumManagement'
import { AdminAlbumDetail } from './pages/AdminAlbumDetail'
import { UserManagement } from './pages/UserManagement'
import { OrphanedImages } from './pages/OrphanedImages'
import { ShareAlbum } from './pages/ShareAlbum'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { useAuthStore } from './stores/authStore'

function App() {
  const initialize = useAuthStore((state) => state.initialize)

  useEffect(() => {
    initialize()
  }, [initialize])

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/album/:id" element={<Album />} />
          <Route path="/share/:id" element={<ShareAlbum />} />
          <Route path="/image/:id" element={<ImageDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/upload" element={<Upload />} />
            <Route path="/admin/albums" element={<AlbumManagement />} />
            <Route path="/admin/albums/:id" element={<AdminAlbumDetail />} />
            <Route path="/admin/users" element={<UserManagement />} />
            <Route path="/admin/orphans" element={<OrphanedImages />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
